module.exports = __webpack_public_path__ + "images/2-3_0_Homepage_HK.jpg?ff97cf7";


//////////////////
// WEBPACK FOOTER
// ./assets/component/index/images/2-3_0_Homepage_HK.jpg
// module id = 333
// module chunks = 0